import React from 'react';
import { styled } from "styled-components";
import imgHowItWork from '../../assets/_HowDoesThisWork.png';
import { t } from 'ttag';

const HowItWorkImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const HowItWork = ({ video }) => {
  return video ? <iframe width="100%" height="315" src={video}
                         title={t`YouTube video player`} frameBorder="0"
                         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                         allowFullScreen></iframe> : <HowItWorkImg src={imgHowItWork} />;
};

export default HowItWork;
